module.exports = __webpack_public_path__ + "media/assets/images/events/20210610_offcar/industry_4point0-7ebd25dcd1ab91c69709217e29269fe6.jpg";